<div class="text-center" id="presentation">

    <div class="services-container text-center ui container">
        <h2>Nos Services</h2>
        <h3 class="service-title">Votre garage Schiltz vous propose une gamme variée de services automobiles.</h3>
        <div class="ui stackable two column grid">
            <div class="text-center column">
                <img class="ui medium image about-img" src="../../../../../../assets/img/new-car-icon.png">
                <h2>Véhicules neufs</h2>
                <h3 class="service-text">En tant qu'agent officiel des marques Renault, Dacia, Suzuki et Ligier, nous nous ferons un plaisir de vous faire une offre suivant vos besoins.
                    Nous vous proposons aussi des financement intéressant ainsi qu'une possibilité de reprise de votre ancien véhicule.</h3>
            </div>

            <div class="text-center column">
                <img class="ui medium image about-img" src="../../../../../../assets/img/occasions-icon.png">
                <h2>Occasions</h2>
                <h3 class="service-text">Découvrez notre centaine de voitures dans notre nouveau showroom.
                    Tous nos véhicules sont vendus, révisé et garanti.
                    Nous vous proposons aussi des financement intéressant ainsi qu'une possibilité de reprise de votre ancien véhicule.</h3>
            </div>

            <div class="text-center column">
                <img class="ui medium image about-img" src="../../../../../../assets/img/garage.png">
                <h2>Ateliers</h2>
                <h3 class="service-text">Nos atelier mécaniques et carrosseries vous proposent les services suivants :
                    Révision, freinage, pneus, diagnostic toutes marques, climatisasions, remplacement de pare-brise, et bien d'autres...</h3>
            </div>

            <div class="text-center column">
                <img class="ui medium image about-img" src="../../../../../../assets/img/car-key.png">
                <h2>Locations</h2>
                <h3 class="service-text">Notre service de locations vous propose de louer voitures, minibus et camionettes.</h3>
            </div>
        </div>

    </div>

    <div class="separator text-center">

    </div>

    <div class="about-container ui container">
        <h2>A Propos de Nous</h2>
        <div class="ui stackable three column grid">
            <employee *ngFor="let employee of employees" [employee]="employee" class="column"></employee>
        </div>

    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/main/presentation/presentation.html